import React from 'react';
import { BookOpenIcon, CalendarIcon, ClockIcon, CreditCardIcon, FileTextIcon, GiftIcon, LockIcon, PrinterIcon, ShieldCheckIcon, StarIcon, UsersIcon } from 'lucide-react';
import { mockupUrl } from '../data/content';
import { Button } from './ui/Button';
export function Hero() {
  return <section className="relative overflow-hidden px-4 pb-14 pt-9 md:pb-20 md:pt-14" data-id="element-230" data-mp="4mrul1r1q1lr">
      <div className="pointer-events-none absolute left-1/2 top-[20%] h-[560px] w-[560px] -translate-x-1/2 rounded-full bg-celeste/20 blur-[120px]" data-id="element-231" data-mp="12a0j75mcfqrz" />
      <div className="relative mx-auto max-w-5xl text-center" data-id="element-232" data-mp="xb5w3rhcfg22">
        <div className="mb-5 inline-flex rounded-full border-2 border-celeste bg-celeste/15 px-4 py-1.5 font-display text-[11px] tracking-wider text-primary md:mb-7 md:text-sm" data-id="element-233" data-mp="sa9s7dwzrtwn">
          🧠 CompraDigitalYa™
        </div>
        <h1 className="headline mx-auto max-w-4xl text-[1.6rem] text-slate-900 md:text-[3.25rem]" data-id="element-234" data-mp="3d33f4zea6vla">
          Combo Completo <span className="text-accent" data-id="element-235" data-mp="384jsewrv5frv">Acompañamiento Terapéutico</span> 2026
        </h1>
        <a href="#pricing" className="group my-6 flex justify-center rounded-3xl focus:outline-none md:my-8" aria-label="Ver las opciones de compra del Combo Completo Acompañamiento Terapéutico" data-id="element-236" data-mp="3j9ah3d0igq55">
          <img className="w-full max-w-[680px] object-contain drop-shadow-[0_26px_40px_rgba(2,132,199,.28)] transition-transform duration-300 group-hover:scale-[1.015]" src={mockupUrl} alt="Mockup del Combo Completo Acompañamiento Terapéutico 2026 con sus 6 tomos y 6 bonos" data-id="element-237" data-mp="3e960lmzlrvex" />
        </a>
        <p className="mx-auto max-w-3xl text-base font-bold leading-relaxed text-slate-800 md:text-xl" data-id="element-238" data-mp="2qkwiow5ifrt2">
          Intervení con criterio. Documentá con precisión.{' '}
          <span className="text-accent" data-id="element-239" data-mp="2hjf8tvip4mct">Trabajá sin improvisar.</span>
        </p>
        <p className="mx-auto mt-4 max-w-3xl text-sm font-medium leading-relaxed text-slate-600 md:text-base" data-id="element-240" data-mp="2hljb690y5daz">
          El sistema N°1 para Acompañantes Terapéuticos que necesitan intervenciones por diagnóstico,
          protocolos de crisis e informes profesionales listos para usar en Argentina.
        </p>
        <div className="mt-6 flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs font-semibold text-slate-600 md:text-sm" data-id="element-241" data-mp="ibyrmia3nc4t">
          <span className="flex items-center gap-1.5" data-id="element-242" data-mp="ddwzl7up42h7">
            <FileTextIcon className="h-4 w-4 text-accent" data-id="element-243" data-mp="dbaqv4w2jgxe" />
            100% PDF
          </span>
          <span className="flex items-center gap-1.5" data-id="element-244" data-mp="1ayjiziqkro8d">
            <ClockIcon className="h-4 w-4 text-accent" data-id="element-245" data-mp="16346au4azydj" />
            Acceso en 5 min
          </span>
          <span className="flex items-center gap-1.5" data-id="element-246" data-mp="111es55lsb4l8">
            <CalendarIcon className="h-4 w-4 text-accent" data-id="element-247" data-mp="x14ldqq64a5b" />
            Edición Profesional 2026
          </span>
          <span className="flex items-center gap-1.5" data-id="element-248" data-mp="3ltgm7o0v2mna">
            <PrinterIcon className="h-4 w-4 text-accent" data-id="element-249" data-mp="3lquf1phvu95l" />
            Listo para imprimir
          </span>
        </div>
        <div className="mt-7" data-id="element-250" data-mp="1x9b42xkwqvaz">
          <Button href="#pricing" className="w-full text-xs md:w-auto md:px-10 md:py-5 md:text-lg" data-id="element-251" data-mp="1xa43fdhjeij3">
            QUIERO EL COMBO COMPLETO AT →
          </Button>
        </div>
        <div className="mt-4 flex flex-wrap justify-center gap-x-4 gap-y-1 text-[11px] font-semibold text-slate-500 md:text-sm" data-id="element-252" data-mp="269zfrlmtwjkp">
          <span className="flex items-center gap-1" data-id="element-253" data-mp="2b1rbeakudfhp">
            <ShieldCheckIcon className="h-3.5 w-3.5 text-accent" data-id="element-254" data-mp="2b2kbispap6qv" />
            Garantía 7 días
          </span>
          <span className="text-celeste" data-id="element-255" data-mp="2kyvmnfd5fqjq">·</span>
          <span className="flex items-center gap-1" data-id="element-256" data-mp="2kxkihefskgs3">
            <LockIcon className="h-3.5 w-3.5 text-accent" data-id="element-257" data-mp="2p0qockyzs5y1" />
            Pago seguro
          </span>
          <span className="text-celeste" data-id="element-258" data-mp="2tzbq4otw6xol">·</span>
          <span className="flex items-center gap-1" data-id="element-259" data-mp="2tz1xsuldkefq">
            <CreditCardIcon className="h-3.5 w-3.5 text-accent" data-id="element-260" data-mp="umpt0a2ni12p" />
            Mercado Pago
          </span>
        </div>
        <div className="mt-10 grid grid-cols-2 gap-3 md:mt-14 md:grid-cols-4" data-id="element-261" data-mp="zkrbotw5zydn">
          <TrustCard icon={<UsersIcon className="h-5 w-5 text-accent" data-id="element-263" data-mp="4acin2hvv72o" />} text="+500 acompañantes ya usan el sistema" data-id="element-262" data-mp="4aurcylqfdrh" />
          <TrustCard icon={<BookOpenIcon className="h-5 w-5 text-accent" data-id="element-265" data-mp="e9jx5t0ct7rd" />} text="6 Tomos listos para aplicar" data-id="element-264" data-mp="3vhfei78o21j8" />
          <TrustCard icon={<GiftIcon className="h-5 w-5 text-accent" data-id="element-267" data-mp="9bs8d7v0a1re" />} text="6 Bonos incluidos gratis" data-id="element-266" data-mp="99xn1sfto7ms" />
          <TrustCard icon={<StarIcon className="h-5 w-5 fill-gold text-gold" data-id="element-269" data-mp="3hnxsmfsiccq1" />} text="4.9/5 · ★★★★★" data-id="element-268" data-mp="3hqsbw3zsbrhv" />
        </div>
      </div>
    </section>;
}
function TrustCard({
  icon,
  text
}: {
  icon: React.ReactNode;
  text: string;
}) {
  return <div className="flex flex-col items-center gap-2 rounded-2xl border-2 border-celeste/40 bg-white p-3 shadow-sm" data-id="element-270" data-mp="3mp3r6u8umu7h">
      <span data-id="element-271" data-mp="2yyhq5mx9ia6z">{icon}</span>
      <span className="text-center text-[11px] font-bold leading-tight text-slate-800 md:text-sm" data-id="element-272" data-mp="2yxohuhinncmq">
        {text}
      </span>
    </div>;
}